module.exports = __webpack_public_path__ + "img/LAZADA_ID.4ab1cbd3.svg";